
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35583",
  depVersions: {
  "documents-public-ui": "static-1.35583",
  "atom": "static-1.5571",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2987",
  "client-types": "static-1.512",
  "cssUtils": "static-1.1122",
  "customer-data-filters-ui": "static-1.41440",
  "customer-data-objects": "static-1.8209",
  "customer-data-property-utils": "static-1.8551",
  "documents-lib": "static-1.35588",
  "emoji-mart": "static-3.9",
  "flux-actions": "static-1.383",
  "FormsCommonComponents": "static-1.86877",
  "FormUrlGenerator": "static-2.5213",
  "foundations-theming-specialty": "static-1.2706",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5330",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6090",
  "hs-test-utils": "static-1.8538",
  "hub-http": "static-1.6704",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12293",
  "HubStyleTokens": "static-2.11986",
  "I18n": "static-7.1715",
  "icons": "static-2.708",
  "jasmine-immutable": "static-1.3436",
  "jasmine-runner": "static-1.6952",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7646",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3381",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5880",
  "quartz": "static-1.7694",
  "react": "static-7.204",
  "react-dlb": "static-1.96",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17238",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5678",
  "react-virtualized": "static-2.114",
  "reference-resolvers": "static-1.8684",
  "reference-resolvers-lite": "static-1.8613",
  "reporting-data": "static-1.69439",
  "reporting-reports": "static-1.69115",
  "reporting-snowflake": "static-1.58055",
  "reporting-testing-lib": "static-1.11372",
  "reporting-visualizations": "static-1.61513",
  "reselect": "static-3.18",
  "sales-content-partitioning": "static-1.9459",
  "sanitize": "static-1.4972",
  "sanitize-text": "static-1.8656",
  "SharedI18nStrings": "static-1.190",
  "SharedLegalStrings": "static-1.2226",
  "signup-constants": "static-1.19990",
  "signup-ui-url-generator": "static-2.8537",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5257",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5250",
  "ui-addon-form-validation": "static-1.11352",
  "ui-asset-management-lib": "static-1.11602",
  "ui-images": "static-2.1282",
  "UIComponents": "static-3.8932",
  "usage-tracker": "static-1.7822",
  "usage-tracker-container": "static-1.7812",
  "usage-tracker-core": "static-1.7672",
  "viral-links-lib": "static-1.7583",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10137",
  "foundations-components": "static-1.8784",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.458",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quick-fetch": "static-1.4243",
  "raven": "static-3.6411",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "rpc-client-utils": "static-1.5166",
  "ui-addon-i18n": "static-1.11645",
  "ui-addon-upgrades": "static-9.18561",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "foundations-assets": "static-1.5389",
  "foundations-theming": "static-1.4990",
  "hub-http-janus": "static-1.913",
  "hub-http-shared-msw-handlers": "static-1.10941",
  "hubspotter-http": "static-1.4987",
  "trellis-components": "static-1.3171",
  "trellis-migration-context": "static-1.78",
  "sassPrefix": "static-1.387",
  "conversations-skeleton-state": "static-1.7618",
  "crm-message-bus": "static-1.44154",
  "customer-data-filters-ui-msw-helpers": "static-1.23875",
  "customer-data-objects-ui-components": "static-1.13535",
  "customer-data-reference-ui-components": "static-1.13674",
  "customer-data-ui-utilities": "static-1.10331",
  "events-data-lib": "static-1.746",
  "framework-builder-read-service-client": "static-1.4348",
  "hs-resources": "static-1.683",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3788",
  "inbound-db-properties-service-client": "static-1.4163",
  "multi-account-reference-resolvers": "static-1.1512",
  "onboarding-tours": "static-1.17425",
  "pulse": "static-1.1149",
  "reporting-datasets-permissions-lib": "static-1.14809",
  "segments-client-types": "static-1.12254",
  "stylex": "static-1.48",
  "trellis-assets": "static-1.3152",
  "trellis-theming": "static-1.1516",
  "ui-addon-teams": "static-1.22039",
  "quartz-auth": "static-1.1369",
  "ui-business-units-lib": "static-1.9596",
  "usage-tracker-session-replay": "static-1.5508",
  "ai-components-ui-library": "static-1.10065",
  "ContentUtils": "static-1.69531",
  "customer-data-properties": "static-1.53129",
  "forms-ai-lib": "static-1.5014",
  "forms-utils-lib": "static-1.13372",
  "foundations-components-test-utils": "static-1.6267",
  "react-dnd-compat": "static-1.5110",
  "react-tinymce": "static-1.56313",
  "tinymce-config": "static-2.55439",
  "ui-gdpr-components": "static-1.10658",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3975",
  "HeadJS": "static-2.829",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3649",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.414",
  "ui-fonts": "static-1.1248",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4805",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.198",
  "quartz-head": "static-1.1359",
  "web-vitals": "static-1.21",
  "batch-promise": "static-1.2049",
  "external-options-client-types": "static-1.4451",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1369",
  "frontend-preferences-client": "static-1.8421",
  "graphql": "static-1.95",
  "persist-promise": "static-1.4206",
  "reporting-client-types": "static-1.2858",
  "apollo-stack-hubspot": "static-3.101",
  "hubspot-apollo-client": "static-1.5382",
  "foundations-components-legacy": "static-1.1809",
  "quartz-routing": "static-1.1124",
  "hs-story-utils": "static-1.9928",
  "react-flip-move": "static-1.85",
  "nested-table": "static-1.728",
  "seat-types-lib": "static-1.1089",
  "timezone-utils": "static-2.5730",
  "react-create-root-preference": "static-1.111",
  "bend-plugin-foundations-components": "static-1.5053",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "opentelemetry-fe-types": "static-1.290",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.665",
  "quartz-test": "static-1.1369",
  "quartz-tracking": "static-1.1073",
  "bend-plugin-chirp-manifest": "static-1.576",
  "chirp-fetch": "static-1.2403",
  "merchandise-lib": "static-1.288",
  "purchase-motions-components": "static-1.6664",
  "ts-schema": "static-1.4408",
  "bender-build-tools": "static-1.3617",
  "bend-plugin-foundations-theming": "static-1.3473",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "restore-request-side-panel-lib": "static-1.2080",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5087",
  "conditional-properties-service-client": "static-1.4126",
  "crm-pipelines-api-client-types": "static-1.4456",
  "event-emitter": "static-1.1461",
  "fdsr-migration-layer": "static-1.511",
  "multi-currency-client-types": "static-1.4021",
  "getting-started-shared-tasks": "static-1.19604",
  "growth-data-modal": "static-1.6169",
  "growth-onboarding-confetti": "static-1.3557",
  "growth-onboarding-next-action-utils": "static-1.3026",
  "navigation-components": "static-1.19216",
  "nest": "static-1.736",
  "onboarding-tours-client": "static-1.5640",
  "onboarding-tours-utils": "static-1.1492",
  "ui-shepherd-react": "static-3.10780",
  "ui-shepherd-tracker": "static-1.8161",
  "ui-universal-auth": "static-1.9786",
  "user-context": "static-1.5554",
  "bend-plugin-pulse": "static-1.652",
  "fast-json-patch": "static-1.76",
  "crm-index-associations-lib": "static-1.6948",
  "stylex-utils": "static-1.182",
  "hubspotter-http-shared-msw-handlers": "static-1.10939",
  "magpie-lib": "static-1.5929",
  "navigation-messaging": "static-1.8543",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.24016",
  "copilot-toolkit": "static-1.12194",
  "cms-field-types": "static-1.5310",
  "content-icons-ui": "static-1.2481",
  "integrations-lib": "static-1.17481",
  "calling-global-api": "static-1.66270",
  "calling-internal-common": "static-1.31822",
  "calling-lifecycle-internal": "static-1.67652",
  "calling-lifecycle-messages": "static-1.59944",
  "commerce-products-lib": "static-1.10971",
  "crm-index-visualization-core": "static-1.4789",
  "crm-links": "static-1.6813",
  "customer-data-properties-shared-msw-handlers": "static-1.10268",
  "data-agent-utils": "static-1.969",
  "data-token-picker": "static-1.17172",
  "file-manager-components": "static-1.24879",
  "formula-editor": "static-1.15042",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4528",
  "meetings-icalendar-utils-lib": "static-1.1130",
  "object-builder-ui-client": "static-1.50103",
  "pipeline-validation-client-types": "static-1.4297",
  "property-value-citations": "static-1.3743",
  "react-colorpicker": "static-2.10708",
  "rich-text-lib": "static-1.20591",
  "smart-data-capture-core": "static-1.531",
  "tiered-pricing": "static-1.2323",
  "tinymce-plugins": "static-1.58553",
  "tinymce-themes": "static-1.57409",
  "topics-actions-lib": "static-1.684",
  "trellis-ext-i18n": "static-1.1423",
  "trial-components-library": "static-1.14423",
  "ui-addon-emoji-picker": "static-1.10364",
  "ui-addon-iframeable": "static-1.9578",
  "zustand": "static-1.91",
  "final-form": "static-1.85",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.84",
  "hub-http-contrib": "static-1.3531",
  "interframe": "static-3.5242",
  "tinymce-data": "static-1.41524",
  "ui-addon-sales-email": "static-1.5702",
  "hubspot-apollo-cache": "static-1.841",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.650",
  "opentelemetry-web": "static-1.25",
  "onboarding-scopes": "static-1.6953",
  "purchase-motions-api": "static-1.6667",
  "onboarding-data-sync-lib": "static-1.2872",
  "growth-onboarding-next-action-components": "static-1.3054",
  "user-context-client": "static-1.5009",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5389",
  "reactive-lib": "static-1.1220",
  "simple-logging-lib": "static-1.3551",
  "custom-vendor-connection-lib": "static-1.350",
  "unified-auth-core-lib": "static-1.1582",
  "getting-started-shared-tasks-store": "static-1.18722",
  "nav-meta": "static-1.30853",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2256",
  "integrations-error-boundary-lib": "static-1.14896",
  "integrations-tracking-lib": "static-1.6123",
  "native-integrations-shared-strings": "static-1.8262",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10870",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31829",
  "shared-worker-versioning": "static-1.11542",
  "calling-usage-tracker": "static-1.7040",
  "customer-data-tracking": "static-1.7371",
  "voice-sms-access-library": "static-1.2526",
  "commerce-permissions": "static-1.1287",
  "growth-payments-core": "static-1.26545",
  "products-iframe-lib": "static-1.8959",
  "products-ui-components-shared-msw-handlers": "static-1.11323",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11024",
  "sales-views-client-types": "static-1.4757",
  "framework-data-schema-resolvers": "static-1.7392",
  "location-customization-utils-lib": "static-1.10467",
  "data-agent-kit": "static-1.956",
  "enrichment-settings-lib": "static-1.291",
  "fsm": "static-1.4256",
  "policy-lib": "static-1.7303",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4642",
  "poll-commands": "static-1.3977",
  "video-components-external": "static-1.12488",
  "video-data-lib": "static-1.36146",
  "bark-lib": "static-1.17034",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6397",
  "react-codemirror": "static-1.11141",
  "FileManagerLib": "static-1.40519",
  "content-assistance-lib": "static-1.8456",
  "FileManagerCore": "static-1.40378",
  "layout-dnd-components": "static-1.13263",
  "layout-dnd-utils": "static-1.12238",
  "ui-brand-identity-lib": "static-1.17004",
  "NamespacedHubStyle": "static-2.9380",
  "embedded-academy-lib": "static-1.16078",
  "hubs-service-types": "static-1.1766",
  "nudge-client-utils": "static-1.3457",
  "salesImages": "static-1.756",
  "InboxConnectUtils": "static-4.15882",
  "meetings-connect-utils-lib": "static-1.8119",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1234",
  "breeze-engine-core": "static-1.1534",
  "highlight.js": "static-1.92",
  "universal-page-editor-lib": "static-1.3512",
  "calling-orchestration-schema": "static-1.37303",
  "ui-addon-opt": "static-4.8916",
  "framework-data-schema-quick-fetch": "static-1.7297",
  "crm-record-cards-service-types": "static-1.3875",
  "trellis-story-utils": "static-1.4999",
  "storybook-react": "static-1.46",
  "content-media-composition-data-lib": "static-1.13636",
  "content-media-compositions": "static-2.17643",
  "media-bridge-lib": "static-1.19676",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16708",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6607",
  "FileManagerImages": "static-1.38030",
  "video-components": "static-1.14490",
  "ui-addon-video-player": "static-1.9122",
  "ui-coaching-tips": "static-1.29608",
  "breeze-artifacts-sdk": "static-1.1066",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30095",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5013",
  "video-embed": "static-1.36980",
  "ContentData": "static-1.69606",
  "layout-data-lib": "static-1.10563",
  "academy-common-lib": "static-1.15539",
  "nudge-custom-function-registry": "static-1.3214",
  "nudge-renderer-utils": "static-1.3533",
  "whisper-core-api": "static-1.7675",
  "crm-record-cards-client": "static-1.105",
  "social-insights-client-types": "static-1.22970",
  "growth-onboarding-feedback-components": "static-1.7080",
  "outpost": "static-1.4629",
  "advanced-menus-core": "static-1.15853",
  "advanced-menus-lib": "static-1.12597",
  "ExportDialog": "static-6.10872",
  "ui-memberships-settings-lib": "static-1.35242",
  "academy-service-client": "static-1.4190",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4894",
  "trellis-ecosystem": "static-1.7886",
  "ui-addon-react-router-dom": "static-1.10025",
  "wootric-nps": "static-1.7311",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15852",
  "simple-menus-lib": "static-1.17369",
  "settings-ui-lib": "static-1.13028",
  "marketplace-ui-apps-core": "static-1.19601",
  "marketplace-ui-common": "static-1.21069",
  "developer-experience-shared-components": "static-1.11041",
  "immutable-less": "static-1.5151",
  "marketplace-ui-client-types": "static-1.18476",
  "ui-addon-integrations-directory-panel": "static-2.8453",
  "ui-extensibility-client-types": "static-1.4414",
  "ai-settings-ui-library": "static-1.8629",
  "ui-product-approvals-common": "static-1.1663",
  "apps-service-types": "static-1.4108",
  "oauth-service-types": "static-1.4636",
  "simple-data-table": "static-1.3860"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35583",
  "atom": "/atom/static-1.5571",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2987",
  "client-types": "/client-types/static-1.512",
  "cssUtils": "/cssUtils/static-1.1122",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41440",
  "customer-data-objects": "/customer-data-objects/static-1.8209",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8551",
  "documents-lib": "/documents-lib/static-1.35588",
  "emoji-mart": "/emoji-mart/static-3.9",
  "flux-actions": "/flux-actions/static-1.383",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86877",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5213",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2706",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5330",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6090",
  "hs-test-utils": "/hs-test-utils/static-1.8538",
  "hub-http": "/hub-http/static-1.6704",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12293",
  "HubStyleTokens": "/HubStyleTokens/static-2.11986",
  "I18n": "/I18n/static-7.1715",
  "icons": "/icons/static-2.708",
  "jasmine-immutable": "/jasmine-immutable/static-1.3436",
  "jasmine-runner": "/jasmine-runner/static-1.6952",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7646",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3381",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5880",
  "quartz": "/quartz/static-1.7694",
  "react": "/react/static-7.204",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17238",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5678",
  "react-virtualized": "/react-virtualized/static-2.114",
  "reference-resolvers": "/reference-resolvers/static-1.8684",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8613",
  "reporting-data": "/reporting-data/static-1.69439",
  "reporting-reports": "/reporting-reports/static-1.69115",
  "reporting-snowflake": "/reporting-snowflake/static-1.58055",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11372",
  "reporting-visualizations": "/reporting-visualizations/static-1.61513",
  "reselect": "/reselect/static-3.18",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9459",
  "sanitize": "/sanitize/static-1.4972",
  "sanitize-text": "/sanitize-text/static-1.8656",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2226",
  "signup-constants": "/signup-constants/static-1.19990",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8537",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5257",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5250",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11602",
  "ui-images": "/ui-images/static-2.1282",
  "UIComponents": "/UIComponents/static-3.8932",
  "usage-tracker": "/usage-tracker/static-1.7822",
  "usage-tracker-container": "/usage-tracker-container/static-1.7812",
  "usage-tracker-core": "/usage-tracker-core/static-1.7672",
  "viral-links-lib": "/viral-links-lib/static-1.7583",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10137",
  "foundations-components": "/foundations-components/static-1.8784",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quick-fetch": "/quick-fetch/static-1.4243",
  "raven": "/raven/static-3.6411",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "rpc-client-utils": "/rpc-client-utils/static-1.5166",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11645",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18561",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "foundations-assets": "/foundations-assets/static-1.5389",
  "foundations-theming": "/foundations-theming/static-1.4990",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10941",
  "hubspotter-http": "/hubspotter-http/static-1.4987",
  "trellis-components": "/trellis-components/static-1.3171",
  "trellis-migration-context": "/trellis-migration-context/static-1.78",
  "sassPrefix": "/sassPrefix/static-1.387",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7618",
  "crm-message-bus": "/crm-message-bus/static-1.44154",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23875",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13535",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13674",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10331",
  "events-data-lib": "/events-data-lib/static-1.746",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4348",
  "hs-resources": "/hs-resources/static-1.683",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3788",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4163",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1512",
  "onboarding-tours": "/onboarding-tours/static-1.17425",
  "pulse": "/pulse/static-1.1149",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14809",
  "segments-client-types": "/segments-client-types/static-1.12254",
  "stylex": "/stylex/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.3152",
  "trellis-theming": "/trellis-theming/static-1.1516",
  "ui-addon-teams": "/ui-addon-teams/static-1.22039",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9596",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5508",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10065",
  "ContentUtils": "/ContentUtils/static-1.69531",
  "customer-data-properties": "/customer-data-properties/static-1.53129",
  "forms-ai-lib": "/forms-ai-lib/static-1.5014",
  "forms-utils-lib": "/forms-utils-lib/static-1.13372",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6267",
  "react-dnd-compat": "/react-dnd-compat/static-1.5110",
  "react-tinymce": "/react-tinymce/static-1.56313",
  "tinymce-config": "/tinymce-config/static-2.55439",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3975",
  "HeadJS": "/HeadJS/static-2.829",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3649",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.414",
  "ui-fonts": "/ui-fonts/static-1.1248",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4805",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.198",
  "quartz-head": "/quartz-head/static-1.1359",
  "web-vitals": "/web-vitals/static-1.21",
  "batch-promise": "/batch-promise/static-1.2049",
  "external-options-client-types": "/external-options-client-types/static-1.4451",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8421",
  "graphql": "/graphql/static-1.95",
  "persist-promise": "/persist-promise/static-1.4206",
  "reporting-client-types": "/reporting-client-types/static-1.2858",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5382",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1809",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "hs-story-utils": "/hs-story-utils/static-1.9928",
  "react-flip-move": "/react-flip-move/static-1.85",
  "nested-table": "/nested-table/static-1.728",
  "seat-types-lib": "/seat-types-lib/static-1.1089",
  "timezone-utils": "/timezone-utils/static-2.5730",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5053",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.290",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.665",
  "quartz-test": "/quartz-test/static-1.1369",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.576",
  "chirp-fetch": "/chirp-fetch/static-1.2403",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "purchase-motions-components": "/purchase-motions-components/static-1.6664",
  "ts-schema": "/ts-schema/static-1.4408",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3473",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2080",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5087",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4126",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4456",
  "event-emitter": "/event-emitter/static-1.1461",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.511",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4021",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19604",
  "growth-data-modal": "/growth-data-modal/static-1.6169",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3557",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3026",
  "navigation-components": "/navigation-components/static-1.19216",
  "nest": "/nest/static-1.736",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5640",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1492",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10780",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8161",
  "ui-universal-auth": "/ui-universal-auth/static-1.9786",
  "user-context": "/user-context/static-1.5554",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.652",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6948",
  "stylex-utils": "/stylex-utils/static-1.182",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10939",
  "magpie-lib": "/magpie-lib/static-1.5929",
  "navigation-messaging": "/navigation-messaging/static-1.8543",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.24016",
  "copilot-toolkit": "/copilot-toolkit/static-1.12194",
  "cms-field-types": "/cms-field-types/static-1.5310",
  "content-icons-ui": "/content-icons-ui/static-1.2481",
  "integrations-lib": "/integrations-lib/static-1.17481",
  "calling-global-api": "/calling-global-api/static-1.66270",
  "calling-internal-common": "/calling-internal-common/static-1.31822",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67652",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59944",
  "commerce-products-lib": "/commerce-products-lib/static-1.10971",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4789",
  "crm-links": "/crm-links/static-1.6813",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10268",
  "data-agent-utils": "/data-agent-utils/static-1.969",
  "data-token-picker": "/data-token-picker/static-1.17172",
  "file-manager-components": "/file-manager-components/static-1.24879",
  "formula-editor": "/formula-editor/static-1.15042",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4528",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1130",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50103",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4297",
  "property-value-citations": "/property-value-citations/static-1.3743",
  "react-colorpicker": "/react-colorpicker/static-2.10708",
  "rich-text-lib": "/rich-text-lib/static-1.20591",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.531",
  "tiered-pricing": "/tiered-pricing/static-1.2323",
  "tinymce-plugins": "/tinymce-plugins/static-1.58553",
  "tinymce-themes": "/tinymce-themes/static-1.57409",
  "topics-actions-lib": "/topics-actions-lib/static-1.684",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1423",
  "trial-components-library": "/trial-components-library/static-1.14423",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10364",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9578",
  "zustand": "/zustand/static-1.91",
  "final-form": "/final-form/static-1.85",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "hub-http-contrib": "/hub-http-contrib/static-1.3531",
  "interframe": "/interframe/static-3.5242",
  "tinymce-data": "/tinymce-data/static-1.41524",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5702",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.841",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.650",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "onboarding-scopes": "/onboarding-scopes/static-1.6953",
  "purchase-motions-api": "/purchase-motions-api/static-1.6667",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2872",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3054",
  "user-context-client": "/user-context-client/static-1.5009",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5389",
  "reactive-lib": "/reactive-lib/static-1.1220",
  "simple-logging-lib": "/simple-logging-lib/static-1.3551",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.350",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1582",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18722",
  "nav-meta": "/nav-meta/static-1.30853",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2256",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14896",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6123",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8262",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10870",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31829",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11542",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7040",
  "customer-data-tracking": "/customer-data-tracking/static-1.7371",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2526",
  "commerce-permissions": "/commerce-permissions/static-1.1287",
  "growth-payments-core": "/growth-payments-core/static-1.26545",
  "products-iframe-lib": "/products-iframe-lib/static-1.8959",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11323",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11024",
  "sales-views-client-types": "/sales-views-client-types/static-1.4757",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7392",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10467",
  "data-agent-kit": "/data-agent-kit/static-1.956",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.291",
  "fsm": "/fsm/static-1.4256",
  "policy-lib": "/policy-lib/static-1.7303",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4642",
  "poll-commands": "/poll-commands/static-1.3977",
  "video-components-external": "/video-components-external/static-1.12488",
  "video-data-lib": "/video-data-lib/static-1.36146",
  "bark-lib": "/bark-lib/static-1.17034",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6397",
  "react-codemirror": "/react-codemirror/static-1.11141",
  "FileManagerLib": "/FileManagerLib/static-1.40519",
  "content-assistance-lib": "/content-assistance-lib/static-1.8456",
  "FileManagerCore": "/FileManagerCore/static-1.40378",
  "layout-dnd-components": "/layout-dnd-components/static-1.13263",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12238",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17004",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9380",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16078",
  "hubs-service-types": "/hubs-service-types/static-1.1766",
  "nudge-client-utils": "/nudge-client-utils/static-1.3457",
  "salesImages": "/salesImages/static-1.756",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15882",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8119",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1234",
  "breeze-engine-core": "/breeze-engine-core/static-1.1534",
  "highlight.js": "/highlight.js/static-1.92",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3512",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37303",
  "ui-addon-opt": "/ui-addon-opt/static-4.8916",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7297",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3875",
  "trellis-story-utils": "/trellis-story-utils/static-1.4999",
  "storybook-react": "/storybook-react/static-1.46",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13636",
  "content-media-compositions": "/content-media-compositions/static-2.17643",
  "media-bridge-lib": "/media-bridge-lib/static-1.19676",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16708",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6607",
  "FileManagerImages": "/FileManagerImages/static-1.38030",
  "video-components": "/video-components/static-1.14490",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9122",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29608",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1066",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30095",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5013",
  "video-embed": "/video-embed/static-1.36980",
  "ContentData": "/ContentData/static-1.69606",
  "layout-data-lib": "/layout-data-lib/static-1.10563",
  "academy-common-lib": "/academy-common-lib/static-1.15539",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3214",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3533",
  "whisper-core-api": "/whisper-core-api/static-1.7675",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.105",
  "social-insights-client-types": "/social-insights-client-types/static-1.22970",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7080",
  "outpost": "/outpost/static-1.4629",
  "advanced-menus-core": "/advanced-menus-core/static-1.15853",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12597",
  "ExportDialog": "/ExportDialog/static-6.10872",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35242",
  "academy-service-client": "/academy-service-client/static-1.4190",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4894",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7886",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10025",
  "wootric-nps": "/wootric-nps/static-1.7311",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15852",
  "simple-menus-lib": "/simple-menus-lib/static-1.17369",
  "settings-ui-lib": "/settings-ui-lib/static-1.13028",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19601",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21069",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11041",
  "immutable-less": "/immutable-less/static-1.5151",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18476",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8453",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4414",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8629",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1663",
  "apps-service-types": "/apps-service-types/static-1.4108",
  "oauth-service-types": "/oauth-service-types/static-1.4636",
  "simple-data-table": "/simple-data-table/static-1.3860"
}
};
